import React from "react";
import HubSpotForm from "./HubspotForm";

export type ReferFormValues = {
  company: string;
  email: string;
  firstname: string;
  lastname: string;
  phone: string;
};

interface ReferFormProps {
  initialValues: ReferFormValues;
}

const ReferForm: React.FC<ReferFormProps> = ({ initialValues }) => {
  return (
    <HubSpotForm
      portalId="39988400"
      formId="f458a7e7-249e-46d4-8bce-49e5b94de29c"
      initialValues={initialValues}
    />
  );
};

export default ReferForm;
